<template>
  <SubscriptionCard
    v-if="
      quote &&
      quote.plan !== SubscriptionPlan.Prolight &&
      !(quote.plan === SubscriptionPlan.Pro && !isProlightMarket) &&
      !(activeSubscription && activeSubscription.cancelled)
    "
    :title="t('admin.cards.upgrade.title')"
    :description="t('admin.cards.upgrade.description')"
    :features="features"
    :buttonLabel="t('admin.cards.upgrade.upgrade_button')"
    :difference="
      difference && basePrice && quote
        ? {
            value: difference,
            currency: basePrice.currency,
            period: quote.period
          }
        : undefined
    "
  />
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useCompanyStore } from '@/stores/company';
import { SubscriptionPlan } from '@/types';
import getCompanySubscription from './get-company-subscription';
import SubscriptionCard from './SubscriptionCard.vue';
import { useCurrentPlanQuote } from './store';

const { t } = useI18n();
const { isProlightMarket } = useCompanyStore();
const { difference, basePrice, quote } = storeToRefs(useCurrentPlanQuote());
const { activeSubscription } = getCompanySubscription();
const features = [
  'online_discount_codes',
  'marketing_newsletters',
  'last_minute_discounts',
  'waiting_list',
];
</script>
